var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 356.501,
    height: 277.664,
    viewBox: "0 0 356.501 277.664",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2577",
    "data-name": "Groupe 2577",
    transform: "translate(356.823 186.98) rotate(164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2947",
    "data-name": "Trac\\xE9 2947",
    d: "M307.705,45.638c-95.233-61.062-196.9-55.71-204.742-14.213s71.341,54.761,63.85,24.006S9.22,40.285,0,173.838",
    transform: "translate(316.381 176.662) rotate(177)",
    fill: "none",
    stroke: "#e30613",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2948",
    "data-name": "Trac\\xE9 2948",
    d: "M0,2.232l13.394,11.16L25.67,0",
    transform: "matrix(-0.995, -0.105, 0.105, -0.995, 319.513, 16.002)",
    fill: "none",
    stroke: "#e30613",
    strokeLinecap: "round",
    strokeWidth: 6
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.5180914977dfb2d67f1c2e09ca8005cc.svg";
export { ForwardRef as ReactComponent };